import request from "@/utils/request.js";
// let path = "/api";
const User = {
  /**
   * 登录获取token
   * @param username @type String 用户名
   * @param password @type String 密码
   */
  Login: async (data) => {
    return await request("post", "/login", data);
  },
  /**
   * @param userName @type String 用户名
   * @param createTime @type String 创建时间
   * @param page @type String 页码
   * @param pageSize @type String 条数
   */
  queryUserList: async (data) => {
    return await request("post", "/user/find", data);
  },
  /**
   * 添加/修改用户
   * @param id @type String 用户名id  再新增的时候直接不传这个参数 在修改的时候再传
   * @param username @type String 用户名
   * @param password @type String 密码
   * @param name @type String 姓名
   * @param appendData @type String 备注
   * @param createTime @type String 创建用户的时间
   */
  addOrUpDateUser: async (data) => {
    return await request("post", "/user/save", data);
  },
  /**
   * @param userId @type String 用户id
   */
  delUser: async (data) => {
    return await request("GET", "/user/logic-del", data);
  },
  /**
   * 自动重新登录 (当没有refresh token API时使用)
   */
  autoReLogin: async () => {
    const params = {
      userName: "font-user",
      password: "admin"
    };
    return await request("post", "/login", params);
  },
};
export default User;



// WEBPACK FOOTER //
// ./src/api/user.js